angular.module('unica_invitation.invitation_controllers')

.controller('InvitationSearchController',
function(
	CONFIG,
	$rootScope, $scope, $stateParams,
	InvitationListService
) {

	$scope.event_id = $stateParams.event_id;

	$scope.invitationList     = [];
	$scope.asyncSelected      = undefined;
	$scope.ibNoResults        = false;
	$scope.loadingInvitations = false;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.searchInvitation = function(search) {
		$scope.loadingInvitations = true;

		InvitationListService
			.search($scope.event_id, search)
			.then(function(data) {
				$scope.loadingInvitations = false;

				if ( data.length > 0 ) {
					$scope.ibNoResults = false;
					$scope.invitationList = data;
					return data;
				} else {
					$scope.invitationList = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};


	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.invitationList = [];
		}
	});

});
